import React from 'react';
import Container from '@/components/UI/mobile/Container';
import IBCell from './components/IBCell';
import { CellList } from './types';

const IBServices = [
  { name: '報修服務', path: '/mobile/fix/fixFrontDesk' },
  { name: '公設預約', path: '/mobile/public/publicAppointmentFrontDesk' },
  { name: '問卷管理', path: '/mobile/questionnaire/questionnaireFrontDesk' },
];

const SmartBuildingCollection: React.FC = () => {
  return (
    <Container>
      <CellList>
        {IBServices.map((service) => (
          <IBCell key={service.name} name={service.name} path={service.path} />
        ))}
      </CellList>
    </Container>
  );
};

export default SmartBuildingCollection;
